import "../components/Header.css"

function Header() {
  return (
    <div className= "header">
      <h1>Graze</h1>
    </div>
  )
}
export default Header